import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useBetween } from "use-between";

import LanguageStates from "./LanguageStates";
import { listLanguage } from "../../../utils/listLanguage";
import english from "../../../assets/images/flags/en.png";
import russian from "../../../assets/images/flags/ru.png";
import turkish from "../../../assets/images/flags/tr.png";
import chinese from "../../../assets/images/flags/cn.png";

const ListLanguage = ({setIsActiveLang}) => {
  const path = useLocation();
  const {setActiveLang, activeLang} = useBetween(LanguageStates);
  const { i18n } = useTranslation();
  let isNotEnLang = false;
  const pieceOfPath = path.pathname.split('/');

  listLanguage.listLang.forEach((item) => {
    if (pieceOfPath[1] === item && !isNotEnLang) {
      isNotEnLang = true;
    }
  })

  const changeLanguage = (lang) => {
    if (setIsActiveLang) {
      setIsActiveLang(false);
    }

    if (listLanguage.listLang.includes(lang)) {
      document.cookie = `lang=${lang}; path=/; max-age=-1`;
      document.cookie = `lang=${lang}; path=/`;
      i18n.changeLanguage(lang);
      setActiveLang(lang);
    }
  };

  const pathDefaultLang = (lang) => {
    const newPath = [...pieceOfPath];

    // Удаляем старый префикс языка, если он есть
    if (listLanguage.listLang.includes(newPath[1])) {
      newPath.splice(1, 1);
    }

    if (lang === listLanguage.defaultLang) {
      return newPath.join('/') || '/';
    } else {
      return `/${lang}${newPath.join('/') === '/' ? '' : newPath.join('/')}`;
    }
  };

  return (
    <ul className="list-language">
      <li>
        <NavLink to={pathDefaultLang('en')} onClick={() => changeLanguage('en')}>
          <img src={english} alt="en" /> English
        </NavLink>
      </li>
      <li>
        <NavLink className={`${activeLang}`} to={pathDefaultLang('ru')} onClick={() => changeLanguage('ru')}>
          <img src={russian} alt="ru" /> Русский
        </NavLink>
      </li>
      <li>
        <NavLink className={`${activeLang}`} to={pathDefaultLang('tr')} onClick={() => changeLanguage('tr')}>
          <img src={turkish} alt="tr" /> Türkçe
        </NavLink>
      </li>
      <li>
        <NavLink className={`${activeLang}`} to={pathDefaultLang('zh-Hant')} onClick={() => changeLanguage('zh-Hant')}>
          <img src={chinese} alt="zh-Hant" /> 繁體中文
        </NavLink>
      </li>
    </ul>
  );
}

export default ListLanguage;